export const RTL_LANGS = ["ar", "he", "fa", "ur"];

const en = {
  slogan: "Connect, Share, Talk, and Converse 50 Languages with ChatMiLu.",
  login: "Log in",
  logout: "Log out",
  signup: "Sign up free",
  heroKicker: "50 languages · one conversation",
  heroTitle: "Text in Any Language, Instantly.",
  heroBody:
    "ChatMiLu uniquely pairs a Multilingual AI companion with TransMessages — an instant messaging translation of every message for seamless conversations in order to stay connected the second it is sent. Additionally, experience a comprehensive digital service that combines AI chat, personalized news updates to keep you informed, manage your schedule effortlessly with an integrated calendar, while smart tools and creative prompts enhance your productivity with task management and reminders.",
  startChatting: "Start Exploring",
  seePlans: "See plans",
  tiles: {
    explore: "Explore",
    assistants: "Assistants",
    prompts: "Popular Prompts",
    instructions: "Instructions",
    elite: "Elite Tools",
    history: "My History",
    suggestions: "Suggestions",
    storytelling: "Storytelling",
  },
  chat: "AI Chat",
  transmessages: "iMessages",
  pricing: "Plans",
  settings: "Settings",
  admin: "Admin",
  language: "Language",
  send: "Send",
  askAnything: "Ask anything in your language…",
  newChat: "New chat",
  newSearch: "New Search",
  yourRooms: "Your chats",
  createRoom: "MiLu Chats",
  joinRoom: "Included",
  typeMessage: "Type in your language…",
  feedback: "Feedback",
};

const dict = {
  en,
  es: {
    ...en,
    login: "Iniciar sesión", logout: "Cerrar sesión", signup: "Regístrate gratis",
    heroKicker: "50 idiomas · una conversación",
    heroTitle: "Habla con cualquiera. En cualquier idioma.",
    heroBody: "ChatMiLu combina un compañero de IA multilingüe con TransMessages: mensajería traducida al instante que elimina la barrera del idioma.",
    startChatting: "Empezar a chatear", seePlans: "Ver planes", chat: "Chat IA",
    pricing: "Planes", settings: "Ajustes", language: "Idioma", send: "Enviar",
    askAnything: "Pregunta lo que quieras en tu idioma…", newChat: "Nuevo chat", newSearch: "Nueva búsqueda",
    yourRooms: "Your chats", createRoom: "MiLu Chats", joinRoom: "Included",
    typeMessage: "Escribe en tu idioma…", feedback: "Comentarios",
  },
  fr: {
    ...en,
    login: "Connexion", logout: "Déconnexion", signup: "Inscription gratuite",
    heroKicker: "50 langues · une conversation",
    heroTitle: "Parlez à tout le monde. Dans toutes les langues.",
    heroBody: "ChatMiLu associe un compagnon IA multilingue à TransMessages : une messagerie traduite instantanément qui supprime la barrière linguistique.",
    startChatting: "Commencer à discuter", seePlans: "Voir les offres", chat: "Chat IA",
    pricing: "Offres", settings: "Paramètres", language: "Langue", send: "Envoyer",
    askAnything: "Posez votre question dans votre langue…", newChat: "Nouveau chat", newSearch: "Nouvelle recherche",
    yourRooms: "Your chats", createRoom: "MiLu Chats", joinRoom: "Included",
    typeMessage: "Écrivez dans votre langue…", feedback: "Avis",
  },
  vi: {
    ...en,
    login: "Đăng nhập", logout: "Đăng xuất", signup: "Đăng ký miễn phí",
    heroKicker: "50 ngôn ngữ · một cuộc trò chuyện",
    heroTitle: "Nói chuyện với bất kỳ ai. Bằng mọi ngôn ngữ.",
    heroBody: "ChatMiLu kết hợp trợ lý AI đa ngôn ngữ với TransMessages — tin nhắn dịch tức thì, xóa bỏ rào cản ngôn ngữ.",
    startChatting: "Bắt đầu trò chuyện", seePlans: "Xem gói", chat: "Trò chuyện AI",
    pricing: "Gói", settings: "Cài đặt", language: "Ngôn ngữ", send: "Gửi",
    askAnything: "Hỏi bất cứ điều gì bằng ngôn ngữ của bạn…", newChat: "Cuộc trò chuyện mới", newSearch: "Tìm kiếm mới",
    yourRooms: "Your chats", createRoom: "MiLu Chats", joinRoom: "Included",
    typeMessage: "Nhập bằng ngôn ngữ của bạn…", feedback: "Phản hồi",
  },
  ar: {
    ...en,
    login: "تسجيل الدخول", logout: "تسجيل الخروج", signup: "إنشاء حساب مجاني",
    heroKicker: "٥٠ لغة · محادثة واحدة",
    heroTitle: "تحدّث مع أي شخص. بأي لغة.",
    heroBody: "يجمع ChatMiLu بين رفيق ذكاء اصطناعي متعدد اللغات وTransMessages — رسائل مترجمة فوريًا تُزيل حاجز اللغة.",
    startChatting: "ابدأ المحادثة", seePlans: "الخطط", chat: "محادثة الذكاء الاصطناعي",
    pricing: "الخطط", settings: "الإعدادات", language: "اللغة", send: "إرسال",
    askAnything: "اسأل أي شيء بلغتك…", newChat: "محادثة جديدة", newSearch: "بحث جديد",
    yourRooms: "Your chats", createRoom: "MiLu Chats", joinRoom: "Included",
    typeMessage: "اكتب بلغتك…", feedback: "ملاحظات",
  },
  zh: {
    ...en,
    login: "登录", logout: "退出", signup: "免费注册",
    heroKicker: "50 种语言 · 一场对话",
    heroTitle: "与任何人交谈，使用任何语言。",
    heroBody: "ChatMiLu 将多语言 AI 伙伴与 TransMessages 即时翻译消息结合，消除每个聊天室的语言障碍。",
    startChatting: "开始聊天", seePlans: "查看套餐", chat: "AI 聊天",
    pricing: "套餐", settings: "设置", language: "语言", send: "发送",
    askAnything: "用你的语言随便问…", newChat: "新对话", newSearch: "新搜索",
    yourRooms: "Your chats", createRoom: "MiLu Chats", joinRoom: "Included",
    typeMessage: "用你的语言输入…", feedback: "反馈",
  },
  hi: {
    ...en,
    login: "लॉग इन", logout: "लॉग आउट", signup: "मुफ़्त साइन अप",
    heroKicker: "50 भाषाएँ · एक बातचीत",
    heroTitle: "किसी से भी बात करें। किसी भी भाषा में।",
    heroBody: "ChatMiLu एक बहुभाषी AI साथी और TransMessages को जोड़ता है — तुरंत अनुवादित संदेश जो भाषा की दीवार हटा देते हैं।",
    startChatting: "चैट शुरू करें", seePlans: "प्लान देखें", chat: "AI चैट",
    pricing: "प्लान", settings: "सेटिंग्स", language: "भाषा", send: "भेजें",
    askAnything: "अपनी भाषा में कुछ भी पूछें…", newChat: "नई चैट", newSearch: "नई खोज",
    yourRooms: "Your chats", createRoom: "MiLu Chats", joinRoom: "Included",
    typeMessage: "अपनी भाषा में लिखें…", feedback: "फ़ीडबैक",
  },
  pt: {
    ...en,
    login: "Entrar", logout: "Sair", signup: "Criar conta grátis",
    heroKicker: "50 idiomas · uma conversa",
    heroTitle: "Fale com qualquer pessoa. Em qualquer idioma.",
    heroBody: "O ChatMiLu une um companheiro de IA multilíngue ao TransMessages — mensagens traduzidas na hora, sem barreira de idioma.",
    startChatting: "Começar a conversar", seePlans: "Ver planos", chat: "Chat IA",
    pricing: "Planos", settings: "Configurações", language: "Idioma", send: "Enviar",
    askAnything: "Pergunte qualquer coisa no seu idioma…", newChat: "Nova conversa", newSearch: "Nova busca",
    yourRooms: "Your chats", createRoom: "MiLu Chats", joinRoom: "Included",
    typeMessage: "Escreva no seu idioma…", feedback: "Feedback",
  },
};

export function t(lang, path) {
  const table = dict[lang] || dict[(lang || "").split("-")[0]] || dict.en;
  return path.split(".").reduce((o, k) => (o ? o[k] : undefined), table) ??
    path.split(".").reduce((o, k) => (o ? o[k] : undefined), dict.en) ?? path;
}
